// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--2TGku","content":"layout-module--content--3nIku","mainContent":"layout-module--main-content--8KBYk"};